import { FulfillmentsApiClient } from '@fourthwall/services/dist/FulfillmentsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const usePushToThirdPartyMutation = createMutationHook(
  FulfillmentsApiClient.pushToThirdParty,
  {
    mutationKey: ['pushToThirdParty'],
  },
)
